import { createRoute } from '@tanstack/react-router';
import { ProtectedLayout } from '../components/protected-layout.tsx';
import { Route as root } from './root.tsx';
export const Route = createRoute({ getParentRoute: () => root, id: '_signedIn', component: ProtectedLayout });
